<template>
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.401883 0.395851C0.657053 0.142305 1.00217 0 1.36188 0C1.7216 0 2.06671 0.142305 2.32188 0.395851L9.02988 7.12485C9.27565 7.37154 9.4171 7.70332 9.42492 8.05145C9.43274 8.39958 9.30633 8.73738 9.07188 8.99485L2.46288 15.6249C2.33842 15.7545 2.18939 15.8581 2.0245 15.9296C1.8596 16.0012 1.68212 16.0392 1.50239 16.0414C1.32267 16.0437 1.14429 16.0102 0.977645 15.9428C0.811 15.8755 0.659418 15.7756 0.531728 15.6491C0.404038 15.5227 0.30279 15.372 0.233881 15.206C0.164973 15.04 0.12978 14.8619 0.130353 14.6822C0.130926 14.5025 0.167253 14.3246 0.237218 14.1591C0.307184 13.9935 0.409389 13.8435 0.537883 13.7179L6.15288 8.01785L0.393883 2.31785C0.26784 2.19133 0.168032 2.04116 0.100189 1.87595C0.0323452 1.71075 -0.00219644 1.53378 -0.0014531 1.35519C-0.000709753 1.1766 0.0353039 0.999918 0.10452 0.835287C0.173736 0.670656 0.274792 0.521319 0.401883 0.395851Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'RightArrowIcon',
  props: {
    isDisabled: {
      type: Boolean,
    },
  },
  computed: {
    color() {
      return this.isDisabled ? '#CFCFCF' : '#2A4067';
    },
  },
};
</script>
  